import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import styles from './ItineraryCard.module.css';
import type { ItineraryCardProps } from './ItineraryCard.types';
import { ItineraryCardBody } from './ItineraryCardBody';
import { ItineraryCardChangeField } from './ItineraryCardChangeField';
import { ItineraryCardContent } from './ItineraryCardContent';
import { ItineraryCardGallery } from './ItineraryCardGallery';
import { ItineraryCardHeader } from './ItineraryCardHeader';
import { ItineraryCardInfoBanner } from './ItineraryCardInfoBanner';
import { ItineraryCardNightStepper } from './ItineraryCardNightStepper';
import { ItineraryCardSubheading } from './ItineraryCardSubheading';
import { ItineraryCardTags } from './ItineraryCardTags';
import { ItineraryCardTrainTimes } from './ItineraryCardTrainTimes';
function ItineraryCardRoot(t0) {
  const $ = _c(6);
  const {
    children,
    variant: t1,
    ref
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const t2 = variant === "leg" && styles.legCard;
  let t3;
  if ($[0] !== t2) {
    t3 = clsx(styles.card, t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== children || $[3] !== ref || $[4] !== t3) {
    t4 = <article ref={ref} data-test-id="ItineraryCard" className={t3}>{children}</article>;
    $[2] = children;
    $[3] = ref;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}
export const ItineraryCard = Object.assign(ItineraryCardRoot, {
  Header: ItineraryCardHeader,
  Gallery: ItineraryCardGallery,
  Tags: ItineraryCardTags,
  Subheading: ItineraryCardSubheading,
  InfoBanner: ItineraryCardInfoBanner,
  TrainTimes: ItineraryCardTrainTimes,
  NightStepper: ItineraryCardNightStepper,
  ChangeField: ItineraryCardChangeField,
  Body: ItineraryCardBody,
  Content: ItineraryCardContent
});